// extracted by mini-css-extract-plugin
export default {"creditbtn":"upi_creditbtn__DkEP7","upiinp":"upi_upiinp__cVI97"};